import React from "react";
import PropTypes from "prop-types";
import Styled from "styled-components";
import DropDownArrowIcon from "../../icons/ArrowDownIcon";
import media from "../../utils/media";

const StyledDropdownContent = Styled.div`
  display: ${props => (props.isOpen ? "block" : "none")};
  border-radius: 16px;
  padding: 12px 0;
  background: ${({ theme }) =>
    theme.darkMode ? theme.computedPrimary : "white"};
  overflow-y: auto;
  left: 18px;
  right: 18px;
  bottom: 0;
  top: 68px;
  position: absolute;
  -webkit-overflow-scrolling: touch;
  direction: ${props => props.theme.scriptDirection || "ltr"};
  max-width: calc(100vw - 38px);
  width: 100%;
  border: 1px solid ${props => (props.theme.darkMode ? "#5D5D5D" : "#DCDCDC")};
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px;

  ${media.tablet`
    min-width: 375px;
    max-width: 400px;
    top: 50px;
    ${props =>
      props.theme.scriptDirection === "rtl"
        ? `
      left: 0;
      right: 0px;
    `
        : `
      left: 0px;
      right: 0;
    `}
  `};
  ${media.desktopEmbedSafe`
  /* change menu location base on text direction */
    margin: unset;
    bottom: ${props => (props.bottom ? `${props.bottom}px` : "unset")};
  `};
  a {
    text-decoration: none;
  };
`;

const StyledDropdownTrigger = Styled.div`
  padding: 0;
  cursor: pointer;
  font-weight:700;
  font-size: .9em;
  transition: color .5s;
  z-index: 100;
  white-space: nowrap;
  direction: ${props => props.theme.scriptDirection || "ltr"};
`;

const StyledDropDownArrowIcon = Styled(DropDownArrowIcon)`
  vertical-align: middle;
  padding:0px 4px;
  fill: ${props => props.theme.appBarText};
`;

const StyledDropDownArrowUpIcon = Styled(StyledDropDownArrowIcon)`
  transform: rotate(180deg);
`;

const Dropdown = props => {
  const children = React.Children.map(props.children, child =>
    React.cloneElement(child, {
      isOpen: props.isOpen,
      toggle: props.toggle
    })
  );
  return <div>{children}</div>;
};

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

const DropdownTrigger = props => (
  <StyledDropdownTrigger onClick={props.toggle} {...props}>
    {props.children}
    {props.arrow && props.isOpen ? (
      <StyledDropDownArrowUpIcon size="11" />
    ) : null}
    {props.arrow && !props.isOpen ? (
      <StyledDropDownArrowIcon size="11" />
    ) : null}
  </StyledDropdownTrigger>
);

DropdownTrigger.propTypes = {
  children: PropTypes.node,
  arrow: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func
};

// Other than arrow, these should required, but something about the
// React.cloneElement does not populate the props on the first pass
DropdownTrigger.defaultProps = {
  children: null,
  isOpen: false,
  toggle: () => {},
  arrow: false
};

const DropdownContent = props => (
  <StyledDropdownContent
    isOpen={props.isOpen}
    width={props.width}
    bottom={props.bottom}
    drop={props.drop}
    className={props.className}
    style={props.style}
  >
    {props.children}
  </StyledDropdownContent>
);

DropdownContent.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  width: PropTypes.string,
  bottom: PropTypes.string,
  drop: PropTypes.string
};

// Other than arrow, these should required, but something about the
// React.cloneElement does not populate the props on the first pass
DropdownContent.defaultProps = {
  isOpen: false,
  toggle: () => {}
};

export { DropdownTrigger, DropdownContent };
export default Dropdown;
